<script setup lang="ts">
import type {Component} from "vue"

import {ChevronsUpDown, Plus} from "lucide-vue-next"
import {ref} from "vue"
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuLabel,
  DropdownMenuSeparator,
  DropdownMenuShortcut,
  DropdownMenuTrigger,
} from '@/components/ui/dropdown-menu'

import {
  SidebarMenu,
  SidebarMenuButton,
  SidebarMenuItem,
  useSidebar,
} from '@/components/ui/sidebar'

const props = defineProps<{
  teams: {
    name: string
    logo: Component
    plan: string
  }[]
}>()

const {isMobile} = useSidebar()
const activeTeam = ref(props.teams[0])
</script>

<template>
  <SidebarMenu>
    <SidebarMenuItem>
      <DropdownMenu>
        <DropdownMenuTrigger as-child>
          <SidebarMenuButton
              size="lg"
              class="data-[state=open]:bg-sidebar-accent data-[state=open]:text-sidebar-accent-foreground"
          >
            <div
                class="flex h-8 w-8 items-center justify-center rounded-lg bg-sidebar-accent text-sidebar-accent-foreground"
            >
              <svg viewBox="0 0 32 32" class="size-8 text-slate-700/85" fill="currentColor" focusable="false"
                   aria-hidden="true">
                <path
                    d="M2.396,12L14,18.188C15.076,18.778,15.344,19,16,19s0.924-0.222,2-0.813L29.604,12C30.936,11.279,31,10.378,31,10c0-0.378-0.064-1.279-1.396-2L18,1.813C16.924,1.222,16.656,1,16,1s-0.924,0.222-2,0.813L2.396,8C1.064,8.721,1,9.622,1,10C1,10.378,1.064,11.279,2.396,12z M18.515,20.19C17.709,20.643,17.073,21,16,21s-1.709-0.357-2.515-0.81L2.166,14.144C1.069,14.837,1,15.646,1,16c0,0.378,0.064,1.279,1.396,2L14,24.188C15.076,24.778,15.344,25,16,25s0.924-0.222,2-0.813L29.604,18C30.936,17.279,31,16.378,31,16c0-0.354-0.07-1.162-1.166-1.856L18.515,20.19z M18.515,26.19C17.709,26.643,17.073,27,16,27s-1.709-0.357-2.515-0.81L2.166,20.144C1.069,20.837,1,21.646,1,22c0,0.378,0.064,1.279,1.396,2L14,30.188C15.076,30.778,15.344,31,16,31s0.924-0.222,2-0.813L29.604,24C30.936,23.279,31,22.378,31,22c0-0.354-0.07-1.162-1.166-1.856L18.515,26.19z"
                />
              </svg>
            </div>
            <div class="flex-1 text-left">
              <span class="truncate text-[1.65em] font-semibold text-sidebar-foreground">
                CRM<span class="font-medium ml-[0.10em]">Político</span>
              </span>
            </div>
            <ChevronsUpDown class="ml-auto"/>
          </SidebarMenuButton>
        </DropdownMenuTrigger>
        <DropdownMenuContent
            class="w-[--reka-dropdown-menu-trigger-width] min-w-56 rounded-lg"
            align="start"
            :side="isMobile ? 'bottom' : 'right'"
            :side-offset="4"
        >
          <DropdownMenuLabel class="text-xs text-muted-foreground">
            Teams
          </DropdownMenuLabel>
          <DropdownMenuItem
              v-for="(team, index) in teams"
              :key="team.name"
              class="gap-2 p-2"
              @click="activeTeam = team"
          >
            <div class="flex size-6 items-center justify-center rounded-sm border">
              <component :is="team.logo" class="size-3.5 shrink-0"/>
            </div>
            {{ team.name }}
            <DropdownMenuShortcut>⌘{{ index + 1 }}</DropdownMenuShortcut>
          </DropdownMenuItem>
          <DropdownMenuSeparator/>
          <DropdownMenuItem class="gap-2 p-2">
            <div class="flex size-6 items-center justify-center rounded-md border bg-transparent">
              <Plus class="size-4"/>
            </div>
            <div class="font-medium text-muted-foreground">
              Add team
            </div>
          </DropdownMenuItem>
        </DropdownMenuContent>
      </DropdownMenu>
    </SidebarMenuItem>
  </SidebarMenu>
</template>
